  <template>
  <div>
  <b-modal style="padding:15px" size="lg" id="IssueFromSiloModal" ref="modal" title="Issue From Silo" ok-title="Submit" cancel-title="Close" 
      @show= "resetModal()" @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.subBtnDisabled == true ? true:false || this.$refs.AddIssueFromSiloForm != undefined ? !this.$refs.AddIssueFromSiloForm.checkValidity() : true">
        <form ref="AddIssueFromSiloForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
            <div class="col-md-6">
              <!--NAME INPUT-->
              <b-form-group  label="Date Issued" label-for="datepicker-1" autocomplete="off">
                  <b-form-datepicker id="datepicker-1" v-model= "DateIssued" placeholder="Choose a date" local="en" required></b-form-datepicker>
               </b-form-group>
            </div>
           
            <div class="col-md-6">
              <b-form-group  label="Total Weight" label-for="Total Weight" autocomplete="off">
                <b-form-input id="TotalWeight" v-model= "TotalWeight" type = "number" required></b-form-input>
              </b-form-group>
            </div>
          </div>
                  
        </form>
      </b-modal>
      <Toaster ref ="toaster"/>
      </div>
      </template>

      <script> 
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../../toaster'
export default {
    name: 'AddCompany',
    data(){
        return{
          moduleName:'Issue From Silo',
          TotalWeight:0,
          DateIssued:null,
          subBtnDisabled:false  
		}
  },
 components:
     {
      Toaster
    },

methods:{

    addWheatIssue(){ 
     this.subBtnDisabled = true;
     axios.post('/wheatIssue/IssueFromSilo',
      {"IssuedDateTime":this.DateIssued,"IssuedWeight":Number(this.TotalWeight),
      "CompanyId":this.$auth.user().companyId,"UserId":this.$auth.user().id
      
      })
      .then(res=>{
        // console.log(res)
            
            if(res.data.status == 1)
            {
                  this.$bvModal.hide('IssueFromSiloModal')
                  this.$refs.toaster.showToast('Sucess','success','Wheat issue has been added successfully')
              
                  this.$parent.getWheatIssues();  
              
                   
            }
             else if(res.data.status == -1)
            {
               
                 this.$refs.toaster.showToast('Error','danger',res.data.msg);
            }
            this.subBtnDisabled = false;
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.AddIssueFromSiloForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
      resetModal() {
     
        this.TotalWeight = 0;
        this.DateIssued = null;
       
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.addWheatIssue()
        
       
      },
 
  
  },
	

}
</script>
